import { SelectionChangedEvent } from "ag-grid-community";
import { MarshallingTypeExclusionEntity } from "domain/entity/MarshallingTypeExclusion/MarshallingTypeExclusionEntity";
import { INITIAL_MARL_TYPE_EXCL_COMP_COL_DEF, transferRowData } from "presentation/constant/MarshallingTypeExclusion/MarshallingTypeExclusionColumnDefinition";
import { MarshallingTypeExclusionConstant } from "presentation/constant/MarshallingTypeExclusion/MarshallingTypeExclusionConstant";
import { useMarshallingTypeExclusionVM } from "presentation/hook/MarshallingTypeExclusion/useMarshallingTypeExclusionVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useMarshallingTypeExclusionTracked } from "presentation/store/MarshallingTypeExclusion/MarshallingTypeExclusionProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";

const MarshallingTypeExclusionTablePanel: React.FC = () => {
    const [criteriaState] = useMarshallingTypeExclusionTracked();
    const criteriaVM = useMarshallingTypeExclusionVM();
    const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);
    const [anaInfoState] = useANAInfoTracked();

    let gridRef: any = useRef();

    useEffect(() => {
        if (!onTableSelectionClicked) return;

        gridRef.current?.gridRef.current.api?.deselectAll();
    }, [onTableSelectionClicked])

    useEffect(() => {
        // const columnDefs = (INITIAL_MARL_TYPE_EXCL_COMP_COL_DEF?.slice());

        //gridRef.current?.gridRef.current.api?.setColumnDefs(columnDefs);
        if (!onTableSelectionClicked) {
            gridRef.current?.gridRef.current.api?.deselectAll();
        }
    })

    const handleRowDoubleClick = useCallback((consGrpComp: MarshallingTypeExclusionEntity) => {
        criteriaVM.onRowDoubleClick(consGrpComp);
    }, [criteriaVM])


    const handleAddClick = useCallback(async () => {
        criteriaVM.onAdd(anaInfoState.operatingUnit);
    }, [criteriaVM, anaInfoState])

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        setOnTableSelectionClicked(true);
        const selectedRows = e.api.getSelectedRows();
        criteriaVM.updateSelectedComponentRows(selectedRows);
    }, [criteriaVM])

    const memoCriteriaComponentTable = useMemo(() => {
        return <NbisTable
            id='CriteriaComponent-table'
            headerLabel={MarshallingTypeExclusionConstant.Title.MARL_TYPE_EXCL_MAIN}
            columns={INITIAL_MARL_TYPE_EXCL_COMP_COL_DEF?.slice()}
            data={transferRowData(criteriaState.criteriaEntityList ?? [])}
            showPaginator={false}
            editable={false}
            showAddIcon={anaInfoState.allowCreate && !criteriaState.masterState.isSliderOpen}
            showDeleteButton={false}
            showReloadIcon={false}
            isScrollHighlighted={true}
            selectionMode={false}
            //rowSelection={"multiple"}
            isRowHighligted={true}
            isNewColumnSetting={true}
            onAddClick={handleAddClick}
            handleSelectionChanged={handleSelectionChange}
            onRowDoubleClick={(e: any) => handleRowDoubleClick(e.data)}
            gridHeight="customHeight"
            customHeight="calc(100vh - 75px)"
            ref={gridRef} />;
    }, [criteriaState.criteriaEntityList, criteriaState.masterState.isSliderOpen, anaInfoState.allowCreate, handleAddClick, handleSelectionChange, handleRowDoubleClick])

    return <>
        {<TableWrapper>{memoCriteriaComponentTable}</TableWrapper>}
    </>;
}

export default memo(MarshallingTypeExclusionTablePanel);